module.exports = __webpack_public_path__ + "img/virtualOrganization.6bd22c3.svg";